import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Chip, IconButton, Tooltip, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { DashboardCardHeader } from "./DashboardCardHeader";

type DashboardMetricTileProps = {
  totalNumber: number;
  caption: string;
  className: string;
  valueClassName: string;
  actions?: ReactNode;
  captionTooltip?: ReactNode;
  metricTestId: string;
};

export const DashboardMetricTile = ({
  totalNumber,
  caption,
  className,
  valueClassName,
  actions,
  captionTooltip,
  metricTestId,
}: DashboardMetricTileProps) => {
  const chipBackgroundClassName =
    className
      .split(" ")
      .find((classToken) => classToken.startsWith("bg-")) ?? "bg-gray-100";
  const rootClassName = [
    "h-fit rounded-t border border-b-0 border-solid",
    className,
  ].join(" ");

  return (
    <DashboardCardHeader
      className={rootClassName}
      testId={metricTestId}
      actions={actions}
      style={{
        backgroundColor: "white",
        borderColor: "#e5e7eb",
        borderBottomWidth: "1px",
      }}
    >
      <Chip
        size="small"
        className={[
          "shrink-0 rounded-full",
          chipBackgroundClassName,
          valueClassName,
        ].join(" ")}
        data-testid={`${metricTestId}-value-chip`}
        label={totalNumber}
        sx={{
          "& .MuiChip-label": {
            paddingLeft: "12px",
            paddingRight: "12px",
          },
        }}
      />
      <div className="flex min-w-0 items-center gap-1">
        <Typography
          variant="body2"
          color="text.primary"
          className="min-w-0 font-medium !text-base"
          sx={{
            overflowWrap: "anywhere",
            textAlign: "left",
          }}
        >
          {caption}
        </Typography>
        {captionTooltip ? (
          <Tooltip title={captionTooltip} arrow describeChild>
            <IconButton
              aria-label={`${caption} info`}
              data-testid={`${metricTestId}-caption-info`}
              size="small"
              sx={{
                color: "text.secondary",
                flexShrink: 0,
                height: 20,
                padding: "2px",
                width: 20,
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
    </DashboardCardHeader>
  );
};
